import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const MinusIcon = ({ color = '#B5BCBD', size = '20px', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 3"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M14.78 0H1.2C.877 0 .577.129.342.343A1.18 1.18 0 0 0 0 1.199c0 .622.578 1.2 1.2 1.2H14.8c.32 0 .62-.129.856-.343.236-.214.343-.535.343-.857 0-.32-.129-.62-.343-.856A1.265 1.265 0 0 0 14.78 0z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

MinusIcon.propTypes = propTypes;

export default MinusIcon;
